import InfoIcon from '@mui/icons-material/Info'
import makeStyles from '@mui/styles/makeStyles'
import IconButton from '@mui/material/IconButton'
import { memo, MouseEvent, TouchEvent, useCallback } from 'react'

interface Props {
  onClick: (
    event: MouseEvent<HTMLButtonElement> | TouchEvent<HTMLButtonElement>
  ) => void
}

const useStyles = makeStyles((theme) => ({
  button: {
    color: 'rgba(113, 128, 150, 0.7)',
    alignSelf: 'start',
    marginTop: theme.spacing(0.5)
  }
}))

const TooltipButton = ({ onClick }: Props) => {
  const { button } = useStyles()

  const handleMouseDown = useCallback(
    (event: TouchEvent<HTMLButtonElement> | MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      event.preventDefault()
      onClick(event)
    },
    [onClick]
  )

  return (
    <IconButton
      className={button}
      aria-label="toggle tooltip"
      onTouchEnd={handleMouseDown}
      onMouseDown={handleMouseDown}
      size="large"
    >
      <InfoIcon />
    </IconButton>
  )
}

export default memo(TooltipButton)
